import { CFDStatus } from "features/cfd/state/cfdAtoms";
import { StudyStatus } from "features/optimization/state/studyAtoms";

export const isOptimizationCancelable = (selectedStudy: StudyStatus | null) => {
  if (selectedStudy === null) {
    return true;
  } else {
    if (selectedStudy.running > 0 && selectedStudy.failed === 0) {
      return false;
    } else {
      return true;
    }
  }
};

export const isCFDCancelable = (selectedCFD: CFDStatus | null) => {
  if (selectedCFD === null) {
    return true;
  } else {
    if (selectedCFD.status_code === 201) {
      return false;
    } else {
      return true;
    }
  }
};
